module.exports = __webpack_public_path__ + "assets/electrocardiogram.6dc503f2.svg";